import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

export const OTHER_SELLERS_FEEDBACK_REASONS = {
  PRICE: 'price',
  SELLER: 'seller',
  NOT_USE: 'not_use',
  SELLER_RATING: 'seller_rating',
  DELIVERY_SPEED: 'delivery_speed',
  OTHER: 'other',
} as const

export type OtherSellersFeedbackReason =
  (typeof OTHER_SELLERS_FEEDBACK_REASONS)[keyof typeof OTHER_SELLERS_FEEDBACK_REASONS]

export interface OtherSellersFeedbackPayload {
  selectedReasons: string[]
  comment?: string | null
  productId?: string | null
  offerId?: string | null
  merchantId?: string | null
}

export interface OtherSellersFakeOfferClickPayload {
  productId?: string | null
  offerId?: string | null
}

const TRACKING_ZONE = 'pdp_other_sellers_fake_door'

export function useOtherSellersTracking() {
  const { trackFormSubmit, trackClick } = useTracking()

  function trackOtherSellersFeedbackSubmitted(
    payload: OtherSellersFeedbackPayload,
  ) {
    const reasonFlags = Object.fromEntries(
      Object.values(OTHER_SELLERS_FEEDBACK_REASONS).map((reason) => [
        reason,
        payload.selectedReasons.includes(reason),
      ]),
    )

    trackFormSubmit({
      zone: TRACKING_ZONE,
      name: 'other_sellers_feedback_submitted',
      ...reasonFlags,
      comment: payload.comment || null,
      productId: payload.productId || null,
      offerId: payload.offerId || null,
      merchantId: payload.merchantId || null,
    })
  }

  function trackOtherSellersFakeOfferClicked(
    payload?: OtherSellersFakeOfferClickPayload,
  ) {
    trackClick({
      zone: TRACKING_ZONE,
      name: 'other_sellers_fake_offer_clicked',
      productId: payload?.productId || null,
      offerId: payload?.offerId || null,
    })
  }

  return {
    trackOtherSellersFeedbackSubmitted,
    trackOtherSellersFakeOfferClicked,
  }
}
